import { render } from "./index.vue?vue&type=template&id=764b2f9b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=764b2f9b&scoped=true&lang=scss"
import "./index.vue?vue&type=style&index=1&id=764b2f9b&lang=css"

import exportComponent from "D:\\peizhe_protal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764b2f9b"]])

export default __exports__